import styled from 'styled-components';

import { Colors } from '../../../constants';

import Button from '../../../components/Button';
import Icon from '../../../components/Icon';

const ModalContainer = styled.div`
  background: #FFF;  
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: var(--luft-primary);
  padding: 16px 24px;
`;

const ModalTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
`;

const ModalContent = styled.div`
  padding: 48px;
`;

const ContentText = styled.div`
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 12px;
`;

const ManageRecipientsButton = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: var(--luft-secondary-darker);
  text-decoration-line: underline;
  cursor: pointer;
`;

const ModalFooter = styled.div`
  margin: 0 48px 48px 48px;  
  display: flex;  
  justify-content: flex-end;
`;

const StyledButton = styled(Button)`
  &:first-child {
    background: #C4C4C4;
    margin-right: 16px;
  }
  
  border-radius: 4px;
  text-transform: uppercase;
`;

const CloseButton = styled(Icon)`
  color: white;
  font-size: 24px;
  cursor: pointer;  
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TrackingActiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

const TrackingActive = styled.span`
  color: var(--luft-primary);
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 18px;  
`;

const ToggleContainer = styled.div`  
  display: flex;
  align-items: center;  
  margin-left: 8px;
`;

const CheckBoxLabel = styled.span`
  display: block;
  margin-left: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 12px;
  text-align: right;
  color: ${({ checked }) => (checked ? Colors.SECONDARY_BLUE : Colors.LIGHT_OPACITY_GREY)} !important;  
`;

const TrackingDisclaimer = styled.span`
  font-style: italic;
  font-size: 16px;
  margin-top: 18px;
  color: #999999;
`;

const WrapperAlert = styled.div`
  margin-top: 32px;
  margin-bottom: -16px;
`;

export const S = {
  ModalHeader,
  ModalTitle,
  ModalContent,
  ContentText,
  ModalContainer,
  WrapperAlert,
  ManageRecipientsButton,
  ModalFooter,
  StyledButton,
  CloseButton,
  Form,
  TrackingActiveContainer,
  TrackingActive,
  ToggleContainer,
  CheckBoxLabel,
  TrackingDisclaimer,
};
